<template>
  <div>
    <div>
      <BaseLabel label="Request data" class="ml-4" />
      <BaseCollapse :items="requestItems" />
    </div>

    <div>
      <BaseLabel label="Response data" class="ml-4" />
      <BaseCollapse :items="responseItems" />
    </div>
  </div>
</template>

<script>

export default {
  name: 'ChatGPTActionDetailApi',

  props: {
    formData: {
      type: Object,
      required: true
    }
  },

  computed: {
    requestItems() {
      const requestItems = []
      if (this.showUnreleased) {
        requestItems.push({
          label: 'Options (UNRELEASED)',
          description: 'Configuration sent to Chat GPT API.',
          value: this.options
        })
      }

      if (this.messageHistory.length) {
        requestItems.push({
          label: `Message history (${this.messageHistory.length})`,
          description: 'Messages sent to provide context to the model for the latest customer query.',
          value: this.messageHistory
        })
      }

      return requestItems
    },

    responseItems() {
      const responseItems = []
      if (this.contextBody) {
        responseItems.push({
          label: 'Response body',
          description: 'Aggregated response body from the API call.',
          value: this.contextBody,
          isContext: true
        })
      }

      if (this.intents) {
        responseItems.push({
          label: 'Intent labels',
          description: 'Chat GPT generated some guesses for the intent of the user\'s message.',
          value: this.intents
        })
      }

      if (this.citations) {
        responseItems.push({
          label: `Citations (${this.citations.length})`,
          description: `Citations of the top ${this.citations.length} documents that are most relevant to the user\'s message.`,
          value: this.citations
        })
      }

      return responseItems
    },
    
    messageHistory() {
      const messageHistory = this.formData?.data?.options?.messages
      if (!messageHistory) return []
      if (this.showUnreleased) return messageHistory

      return messageHistory.map(message => {
        if (
          message.content.startsWith('If you are tasked with generating a list of products') ||
          message.content.startsWith('1. If the user is asking for product/service recommendations')
        ) {
          return {
            ...message,
            content: '**AMIO PROMPT HIDDEN**'
          }
        }
        return message
      })
    },

    options() {
      return this.formData?.data?.options
    },

    contextBody() {
      return this.formData?.data?.context?.body
    },

    intents() {
      return this.formData?.data?.intent
    },

    citations() {
      if (!this.formData?.data?.citations) return null

      return this.formData.data.citations.map(citation => {
        return {
          ...citation,
          content: this.parseCitationContent(citation.content)
        }
      })
    }
  },
  methods: {
    parseCitationContent(content) {
      if (!content || typeof content !== 'string') return content

      try {
        // First try to parse as JSON
        return JSON.parse(content)
      } catch {
        // If not JSON, try to parse as comma-separated key-value pairs
        const obj = {}
        const pairs = content.split(',')
        
        for (const pair of pairs) {
          const colonIndex = pair.indexOf(':')
          if (colonIndex > 0) {
            const key = pair.substring(0, colonIndex).trim()
            const value = pair.substring(colonIndex + 1).trim()
            
            // Try to parse numeric values
            if (!isNaN(value) && value !== '') {
              obj[key] = Number(value)
            } else {
              obj[key] = value
            }
          }
        }
        
        return obj
      }
    }
  }
}
</script>
